// extracted by mini-css-extract-plugin
export var planCard = "_ve-0";
export var planList = "_ve-1";